import { render } from "./Oceancalender.vue?vue&type=template&id=6b6ba9df&scoped=true"
import script from "./Oceancalender.vue?vue&type=script&lang=js"
export * from "./Oceancalender.vue?vue&type=script&lang=js"

import "./Oceancalender.vue?vue&type=style&index=0&id=6b6ba9df&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6ba9df"]])

export default __exports__